import React from 'react'

const ErrorComponent = ({message}) => {
  return (
    <div>
      {message}
    </div>
  )
}

export default ErrorComponent
